import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { IOpenForm } from "./Support";
import { format } from "date-fns";
import { ConfirmDialog } from "primereact/confirmdialog";
import { NoteActivities } from "./Activities";
import { TicketHistory } from "./History";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";

interface Iprops {
    setModal: (modal: IOpenForm) => void;
    toast: any;
    reload: boolean;
    reloadData: () => void;
    hasPermission: (pageName: string, featureName?: string) => boolean;
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: any[]; count: number; loading: boolean });
    const [text, setText] = useState<string | null>(null);
    const [preview, setPreview] = useState<{ open: boolean; url: string; type: string }>({ open: false, url: "", type: "" });
    const [openActivity, setOpenActivity] = useState({ singleData: {}, open: false } as { singleData: any; open: boolean });
    const [expandedRows, setExpandedRows] = useState<{ [key: string]: any }>({});
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);
    const [filterDate, setFilterDate] = useState<string>("");

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: "id",
        sortOrder: -1,
    });

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, props.reload, filterDate]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    };

    const exportCSV = () => {
        dt.current?.exportCSV();
    };

    // const loadTableData = async () => {
    //     setTableData((prev) => ({ ...prev, loading: true }));
    //     const response = await Fetch("Support/getTicket", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}${text ? "&text=" + text : ""}`, props.toast);
    //     if (response) {
    //         const data: { result: any[]; totalCount: number } = await response.json();
    //         setTableData({ data: data.result, count: data.totalCount, loading: false });
    //     } else {
    //         setTableData((prev) => ({ ...prev, loading: false }));
    //     }
    // };

    const loadTableData = async () => {
        setTableData(prev => ({ ...prev, loading: true }));

        const finalFilter = {
            date: filterDate || ""
        };

        const _query = new URLSearchParams({
            lazyParams: JSON.stringify(lazyParams),
            filter: JSON.stringify(finalFilter),
            text: text || ""
        }).toString();

        const response = await Fetch("Support/getTicket", "GET", "", _query, null);

        if (response) {
            const data = await response.json();
            setTableData({
                data: data.result,
                count: data.totalCount,
                loading: false
            });
        } else {
            setTableData(prev => ({ ...prev, loading: false }));
        }
    };


    const openNew = () => {
        props.setModal({ open: true, singleData: {} });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                <Button style={{ width: "80px", height: "30px" }} label="New" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={openNew} />
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: "uppercase", fontFamily: "Rancho", letterSpacing: 1 }}>Ticket Raise</h4>
                </div>
                <div className="flex gap-4">
                    <Calendar showIcon
                        className="custom-calendar"
                        inputClassName="custom-calendar-input"
                        value={selectedDate}
                        onChange={(e) => {
                            const value = e.value;
                            if (value instanceof Date) {
                                setSelectedDate(value);
                                const d = value.toISOString().split("T")[0];
                                setFilterDate(d);
                            } else {
                                setSelectedDate(undefined);
                                setFilterDate("");
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );

    const previewAttachment = (fileUrl: string) => {
        if (!fileUrl) return;
        const lower = fileUrl.toLowerCase();
        if (lower.endsWith(".jpg") || lower.endsWith(".jpeg") || lower.endsWith(".png")) {
            setPreview({ open: true, url: fileUrl, type: "image" });
        } else if (lower.endsWith(".pdf")) {
            setPreview({ open: true, url: fileUrl, type: "pdf" });
        } else {
            window.open(fileUrl, "_blank");
        }
    };

    const openEdit = (rowDatauser: any) => {
        props.setModal({ open: true, singleData: rowDatauser, isDisable: true });
    };
    const rowExpansionTemplate = (rowData: any) => {
        return (
            <div style={{ width: "100%" }}>
                <TicketHistory
                    hasPermission={props.hasPermission}
                    singleData={rowData}
                    toast={props.toast}
                    reloadData={props.reloadData}
                />
            </div>
        );
    };


    const actionBodyTemplate = (rowData: any) => {
        return (
            <div className="actions" style={{ display: "flex", gap: 8 }}>
                <Button icon="pi pi-pencil" className="p-button-success p-button-text p-0" onClick={() => openEdit(rowData)} tooltip="Edit" />
                <Button icon="pi pi-plus" className="p-button-success p-button-text p-0" onClick={() => setOpenActivity({ open: true, singleData: rowData })} />
                <Button
                    icon="pi pi-eye"
                    className="p-button-success p-button-text p-0"
                    onClick={() => {
                        const key =
                            rowData.ticket_Number ??
                            rowData.ticket_Id ??
                            rowData.ticketnumber ??
                            rowData.ticketNumber;

                        setExpandedRows((prev) => {
                            const newState = { ...(prev || {}) };

                            if (newState[key]) {
                                delete newState[key];
                            } else {
                                newState[key] = rowData;
                            }

                            return newState;
                        });
                    }}
                />

                {rowData.file && <Button icon="pi pi-link" className="p-button-success p-button-text p-0" onClick={() => previewAttachment(rowData.file)} />}
            </div>
        );
    };

    return (
        <>
            <DataTable
                style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }}
                ref={dt}
                size="small"
                stripedRows
                scrollable
                scrollHeight="75vh"
                exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
                value={tableData.data}
                lazy
                paginator
                first={lazyParams.first}
                rows={lazyParams.rows}
                rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count}
                onPage={onPage}
                onSort={onSort}
                sortField={lazyParams.sortField}
                sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
                onRowToggle={(e: any) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
                dataKey="ticket_Number"
                expandedRows={expandedRows}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="ticket_Id" header="TICKET NO." />
                <Column field="application_Group_Name" header="APPLICATION" />
                <Column field="priority" header="PRIORITY" />
                <Column field="impact" header="IMPACT" />
                {/* <Column field="subject" header="SUBJECT" /> */}
                <Column field="assigned_Grouped_Name" header="ASSIGNED GROUP" />
                <Column field="agent_Name" header="ASSIGNED TO" />
                <Column field="status_Name" header="STATUS" />
                <Column field="open" header="CREATED AT" />
                {/* <Column field="agent_Name" header="AGENT" sortable /> */}
                <Column header="ACTIONS" body={actionBodyTemplate} />
            </DataTable>

            <ConfirmDialog />
            <NoteActivities hasPermission={props.hasPermission} singleData={openActivity.singleData} open={openActivity.open} hideDialog={() => setOpenActivity({ singleData: {}, open: false })} toast={props.toast} reloadData={props.reloadData} />

            <Dialog header="Attachment Preview" visible={preview.open} style={{ width: "60vw" }} modal onHide={() => setPreview({ open: false, url: "", type: "" })}>
                {preview.type === "image" && <img src={preview.url} alt="Attachment" style={{ width: "100%", borderRadius: "8px" }} />}
                {preview.type === "pdf" && <embed src={preview.url} type="application/pdf" width="100%" height="600px" />}
            </Dialog>
        </>
    );
};
